import { all, takeEvery } from 'redux-saga/effects'

import { sendMessage } from '../helpers'

import { SOCKET_ACTION_TYPE } from '../constants'
import { OPEN_DIALOG, CLOSE_DIALOG } from '../../dialog/constants'

function* wsPreventDialogOverlayCallSaga(_action) {
    const { type } = _action
    const { PREVENT_DIALOG_OVERLAY } = SOCKET_ACTION_TYPE

    yield sendMessage(PREVENT_DIALOG_OVERLAY, {
        type: PREVENT_DIALOG_OVERLAY,
        shouldShow: type === OPEN_DIALOG,
    })

    return null
}

const shouldPreventDialogOverlay = (_action) => _action.type === OPEN_DIALOG || _action.type === CLOSE_DIALOG

export default function* dialogSaga() {
    yield all([takeEvery(shouldPreventDialogOverlay, wsPreventDialogOverlayCallSaga)])
}
